export const TAG_INPUT_PLACEHOLDER = 'Please input email addresses; separate multiple recipients with a semicolon (;)';

export const EMAIL_ERROR_MSG =
  'The email address is invalid or in an incorrect format. Please update it and try again.';
